<iframe
  width="600"
  height="450"
  style="border:0"
  loading="lazy"
  allowfullscreen
  src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCVZbBx2Y02PVsF_g95p19UddcMhJH3rsE
    &q=Vision+Indradhanu,+Phase+II,+Chikali+Moshi+Link+road,+Jadhavwadi,+Pune-411062">
</iframe>